/**
 * Narrowing the account's tools to one integration, and to the ones that only read or the ones
 * that change something.
 */

export type ToolAccess = 'read' | 'write';

/** The tool server marks a tool that changes something as high risk; every other tool only reads. */
export const toolAccess = (riskLevel: string): ToolAccess => (riskLevel === 'high' ? 'write' : 'read');

export interface ToolFilter {
	/** One integration, or null for all of them. */
	provider: string | null;
	access: ToolAccess | 'all';
}

export const matchesToolFilter = (
	tool: { provider: string; riskLevel: string },
	{ provider, access }: ToolFilter
): boolean => (provider === null || tool.provider === provider) && (access === 'all' || toolAccess(tool.riskLevel) === access);
